<div *ngIf="authoringContentData" id="managePopUp">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ authoringContentData?.managePairing?.managePairingCTA }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="manageLineService.close()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <div class="container-fluid">
            <div class="divSpacing">
                {{ authoringContentData?.managePairing?.instructionTxt?.partOne }}
                <strong>{{ authoringContentData?.managePairing?.instructionTxt?.partTwo }}</strong>
                {{ authoringContentData?.managePairing?.instructionTxt?.partThree }}
                <strong>{{ authoringContentData?.managePairing?.instructionTxt?.partFour }}</strong>
            </div>
            <div class="col-12 col-sm-12 col-md-6 divSpacing inputFieldDiv">
                <mat-radio-group name="actionRadio" [formControl]="radioOptionSelected" (change)="onInputEligibilityCheck(); setInputLineLabels();">
                    <div class="row">
                        <div class="col-3">
                            <mat-radio-button [disabled]="disablePair" id="pairRadioBtn" value="PAIR">
                                {{authoringContentData?.managePairing?.radioBtnPair}}
                            </mat-radio-button>
                        </div>
                        <div class="col-9 addMargin1">
                            <mat-radio-button [disabled]="disableUnpair" id="unpairRadioBtn" value="UNPAIR">
                                {{authoringContentData?.managePairing?.radioBtnUnpair}}
                            </mat-radio-button>
                        </div>
                    </div>
                </mat-radio-group>
            </div>
            <div class="col-12 col-sm-12 col-md-6 linesSpacing inputFieldDiv">
                <form class="manage-pairing-form">
                    <mat-form-field class="example-full-width">
                        <mat-label>{{ gsmLineLabel }}</mat-label>
                        <input (keypress)="($event.charCode >= 48 && $event.charCode < 58)" (ngModelChange)="onInputEligibilityCheck()" maxlength="10" type="tel" matInput [formControl]="gsmLineFormControl"
                                placeholder="714-555-5555">
                        <mat-error *ngIf="gsmLineFormControl.invalid">
                            {{authoringContentData?.managePairing?.invalidLineMsg}}
                        </mat-error>
                    </mat-form-field>
                </form>
            </div>
            <div class="col-12 col-sm-12 col-md-6 linesSpacing inputFieldDiv">
                <form class="manage-pairing-form">
                    <mat-form-field class="example-full-width">
                        <mat-label>{{ digitLineLabel }}</mat-label>
                        <input (keypress)="($event.charCode >= 48 && $event.charCode < 58)" (ngModelChange)="onInputEligibilityCheck()" maxlength="10" type="tel" matInput [formControl]="digitsLineFormControl"
                                placeholder="714-555-5555">
                        <mat-error *ngIf="digitsLineFormControl.invalid">
                            {{authoringContentData?.managePairing?.invalidLineMsg}}
                        </mat-error>
                    </mat-form-field>
                </form>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="col-12 advisementMsg">
            <div>
                Advisements:
                <br><br>
                {{authoringContentData?.managePairing?.advisementMsg}}
            </div>
        </div>
        <div class="row mx-0">
            <div class="col-12 col-sm-12 col-md-6 mb-4">
                <button type="button" class="btn primary_btn w-100" (click)="submitChange()" [disabled]="!enableSubmitButton">
                    {{authoringContentData?.managePairing?.submitPairingBtn}}
                </button>
            </div>
        </div>
    </div>
  </div>